/* @flow */

export const validation = {
  headingMaxChar: 120,
  paragraphMaxChar: 1500,
  blockTitleMaxChar: 100,
  blockParagraphMaxChar: 500,
  slides: {
    min: 1,
    max: 10
  }
}
